// Google Analytics 4 event tracking helper

declare global {
  interface Window {
    gtag: (...args: unknown[]) => void;
  }
}

/**
 * Track a button click event in Google Analytics 4
 * @param buttonName - Unique identifier for the button (e.g., 'get_lifetime_access')
 * @param location - Where the button is located (e.g., 'hero', 'pricing')
 */
export const trackButtonClick = (buttonName: string, location: string): void => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'button_click', {
      button_name: buttonName,
      button_location: location,
    });
  }
};
